<sp-timer
    [isDeviceMobile]="isDeviceMobile$ | async"
    [isDeviceTablet]="isDeviceTablet$ | async"
    [timerData]="widgetData"
    [classes]="classes"
    [timerId]="getWidgetId"
    [id]="getWidgetId"
></sp-timer>
